import {
  adjustToTimeZone,
  DispatchRequestEntity,
  dispatchRequestsSelector,
  startOfDay,
  subDays,
  useGetPendingDispatchRequestsQuery
} from "@ots-frontend/ots-data";
import {skipToken} from "@reduxjs/toolkit/query";
import {useApp} from "@ots-frontend/ots-ui";
import {useMemo} from "react";

export type UseGetPendingDispatchRequestsProps = {}

export type UseGetPendingDispatchRequestsResult = {
  dispatchRequests: DispatchRequestEntity[],
  isLoading: boolean
  isFetching: boolean
  refetch: any
}

export const useGetPendingDispatchRequests = (props: UseGetPendingDispatchRequestsProps = {}): UseGetPendingDispatchRequestsResult => {
  const {} = props

  const {regionId} = useApp()

  const selectDispatchRequests = useMemo(() => {
    return dispatchRequestsSelector();
  }, []);

  const arg = useMemo(() => {
    if (regionId) {
      return {
        fromDttm: adjustToTimeZone(startOfDay(subDays(new Date(), 3))).getTime(),
        regionId: regionId,
      }
    }

    return skipToken
  }, [regionId])

  const {dispatchRequests, isLoading, isFetching, refetch} = useGetPendingDispatchRequestsQuery(arg, {
    pollingInterval: 240000,
    refetchOnMountOrArgChange: 120,
    selectFromResult: (result) => ({
      ...result,
      dispatchRequests: selectDispatchRequests(result, {}),
      isLoading: result.isLoading,
      isFetching: result.isFetching,
    })
  });

  return {
    dispatchRequests: dispatchRequests,
    isLoading: isLoading,
    isFetching: isFetching,
    refetch: refetch,
  }
}
